import React, { useState } from "react";
import {
  RadialBarChart,
  RadialBar,
  Tooltip,
  Cell,
} from "recharts";

const CustomTooltip = ({ active, payload }) => {
  if (!active || !payload?.length) return null;

  const data = payload[0]?.payload;

  return (
    <div
      style={{
        background: "#fff",
        border: "1px solid #ddd",
        borderRadius: "8px",
        padding: "8px 12px",
        boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
      }}
    >
      <div className="font-medium">{data.name}</div>
      <div style={{ color: data.fill }}>
        Value: <strong>{data.value}</strong>
      </div>
    </div>
  );
};

const CustomRadialBarChart = ({
  data,
  width = 200,
  height = 200,
  innerRadius = "25%",
  outerRadius = "100%",
}) => {
  const [activeIndex, setActiveIndex] = useState(null);

  const handleLegendClick = (index) => {
    setActiveIndex(index === activeIndex ? null : index);
  };

  return (
    <div className="flex items-center gap-4">
      <RadialBarChart
        width={width}
        height={height}
        innerRadius={innerRadius}
        outerRadius={outerRadius}
        data={data}
      >
        <RadialBar
          dataKey="value"
          nameKey="name"
          background
          clockWise
          minAngle={10}
          cornerRadius={10}
        >
          {data.map((entry, index) => (
            <Cell
              key={index}
              fill={entry.fill}
              opacity={
                activeIndex === null || activeIndex === index ? 1 : 0.3
              }
            />
          ))}
        </RadialBar>

        <Tooltip content={<CustomTooltip />} />
      </RadialBarChart>

      {/* Custom Legend */}
      <div className="flex flex-col gap-2">
        {data.map((item, index) => (
          <div
            key={index}
            onClick={() => handleLegendClick(index)}
            className="flex items-center gap-2 cursor-pointer"
          >
            <div
              className="w-4 h-4 rounded-full"
              style={{
                backgroundColor: item.fill,
                opacity:
                  activeIndex === null || activeIndex === index ? 1 : 0.3,
              }}
            />
            <span className="text-sm">{item.name}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default CustomRadialBarChart;